/** @format */

import { h } from 'vue';

/** @format */
const comps = {}; // ./components下的组件

const modules = import.meta.glob('./*.vue', { eager: true });
for (const path in modules) {
	const cname = path.replace(/(\.\/|\.vue)/g, '');
	comps[cname] = (modules[path] as any).default;
}

const getComponentMobile = (type: string) => {
	if (!comps[`${type}`]) {
		console.error(`没有${type}类型组件`);
		return h('div');
	} else {
		return comps[`${type}`];
	}
};

export { getComponentMobile };

export default comps;
